export default {
  shape: `
    <path d="M13.4991 0.00312852C13.1247 0.00312852 12.7792 0.175891 12.5201 0.435035C9.75587 3.19923 7.65393 5.50272 5.09128 8.12295L2.35588 5.81945C1.75121 5.30116 0.829811 5.38756 0.340317 5.99222C-0.17797 6.59689 -0.0915889 7.51829 0.51308 8.00779L4.25627 11.1751C4.83214 11.6646 5.66716 11.607 6.21424 11.0887C9.32396 7.97899 11.5123 5.50273 14.5644 2.4506C15.1403 1.90352 15.1403 0.982105 14.5932 0.40623C14.2765 0.147087 13.9022 -0.0256652 13.4991 0.00312852Z" fill="#34C85A"/>
    `,
};
